import {isApiTrue} from "../is-api-true";

export const to_isAddressable = (templateOptions) => isApiTrue(
    templateOptions.options.find((o) => o.devKey === "is_addressable")?.value
);
